module.exports = __webpack_public_path__ + "media/images/about-you-bg-21681b2af8e55567945ef88779e661a3.svg";